<div class="bigPage">
  <div *ngIf="dataEvento; else loading" class="feedback_cont">
    <!-- HEADER DE LA VISTA -->
    <div class="bigPage_header">
      <div class="bigPage_nav">
        <h3 class="mat-headline">{{dataEvento.categoria}}</h3>
        <span class="spacer"></span>
        <a class="enlace-boton" [routerLink]="['/', 'estudio', 'unidad', unidadID]" fragment="evidencias"><i
            class="material-icons">
            arrow_back
          </i><span>Volver a evidencias</span></a>
      </div>
      <div>
        <div class="bigPage_data">
          <h3 class="mat-small">Evidencia</h3>
          <p class="mat-chip-frame">{{dataEvento.nombre}}</p>
          <h3 class="mat-small">Metas relacionadas</h3>
          <mat-chip-set>
            <mat-basic-chip *ngFor="let meta of dataEvento.metas"
              matTooltip="{{meta.txtFR.length > 3 ? meta.txtFR : meta.txtEN.length > 3 ? meta.txtEN : meta.txtES}}">
              {{meta.codigo}}-{{meta.id}}
            </mat-basic-chip>
          </mat-chip-set>
        </div>
      </div>
    </div>
    <!-- FIN HEADER DE LA VISTA -->
    <div class="bigPage-cont">
      <div class="flex-wrap bigPage_content">
        <div class="bigPage_main">
          <div *ngIf="materiaActivaID">
            <div class="flex-wrap" style="align-items: center;">
              <h3 class="mat-h2">Alumnos</h3>
              <span class="spacer"></span>
              <div class="inline-flex">
                <mat-checkbox #allControl color="primary" (change)="checkStatus($event.checked)">
                  {{allControl.checked ? 'Desmarcar todos' : 'Marcar todos'}}
                </mat-checkbox>
              </div>
              <button mat-raised-button color="primary" [disabled]="printButtonStatus()" (click)="pdfDataModal()">
                <mat-icon>print</mat-icon>
                Imprimir
              </button>
            </div>
            <mat-accordion>
              <ng-container *ngFor="let alumno of getAlumnos()">
                <mat-expansion-panel (opened)="verEvaluacionAlumno(alumno)" [disabled]="alumno.criterios.length == 0">
                  <mat-expansion-panel-header (mouseenter)="alumno.showInput = true"
                    (mouseleave)="alumno.showInput = false">
                    <mat-panel-title style="flex-basis: 0; flex-grow:1; align-items:center;">
                      <div class="flex-wrap">
                        <ng-container *ngIf="!alumno.checked && !alumno.showInput">
                          <div class="user-img-cont" *ngIf="alumno.userImage; else icono_usuario">
                            <img class="user-img" src="{{alumno.imageUrl}}">
                          </div>
                          <ng-template #icono_usuario>
                            <mat-icon>account_circle</mat-icon>
                          </ng-template>
                        </ng-container>
                        <ng-container *ngIf="(alumno.checked || alumno.showInput)">
                          <div style="width: 32px; height: 32px; margin-right: 8px; display: flex; align-items: center; justify-content: center;">
                            <mat-checkbox color="primary" [disableRipple]="true" (click)="$event.stopPropagation();"
                              [(ngModel)]="alumno.checked"></mat-checkbox>
                          </div>
                        </ng-container>
                      </div>
                      {{alumno.apellidosNombres}}
                    </mat-panel-title>
                    <mat-panel-description style="flex-basis: 0; flex-grow:1;">
                      <div style="margin: 0 1px; width: 100%;" class="inline-flex">
                        {{alumno.criteriosEvaluados}} de {{alumno.criteriosTotales}}
                      </div>
                      <span class="spacer"></span>
                      <button class="md-14" mat-icon-button matTooltip="Retroalimentar"
                        (click)="$event.stopPropagation();retroalimentarAlumno(alumno);">
                        <mat-icon class="md-14">spellcheck</mat-icon>
                      </button>
                      <button class="md-14" [disableRipple]="true" mat-icon-button (click)="$event.stopPropagation();">
                        <mat-icon class="md-14">comment</mat-icon>
                        <sup class="notificaciones-capsule"
                          *ngIf="alumno.comentariosNuevos > 0">{{alumno.comentariosNuevos}}
                        </sup>
                      </button>
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <div *ngIf="alumno.evaluacion">
                    <ng-container *ngFor="let metaEval of alumno.evaluacion">
                      <ng-container *ngFor="let criterioEval of metaEval.criterios">
                        <div class="flex-wrap criterio-row mat-elevation-z2">
                          <div class="inline-flex criterio">
                            <label style="opacity:.6">
                              <small><strong>Criterio</strong></small>
                            </label>
                            <p>{{criterioEval.nombre}}</p>
                            <p style="opacity:.6;">
                              <small>{{metaEval.codigo}}-{{metaEval.id}}</small>
                            </p>
                          </div>
                          <div class="inline-flex" style="flex-grow: 5;">
                            <ng-container *ngFor="let nivel of criterioEval.niveles">
                              <div class="flex-wrap">
                                <ng-container *ngFor="let criterioHijo of nivel.criterios">
                                  <div *ngIf="criterioHijo['isSeleccionado']"
                                    [ngClass]="{'logro_seleccion': criterioHijo['isSeleccionado']}"
                                    class="logro_evaluado">
                                    <label style="opacity:.6">
                                      <small>
                                        <strong>{{criterioHijo.escala.nombre}}</strong>
                                      </small>
                                    </label>
                                    <ng-container>
                                      <div>
                                        <p *ngIf="criterioHijo.escala.nickName !== 'P'; else pendiente">
                                          {{criterioHijo.nombre}}</p>
                                        <ng-template #pendiente>
                                          <p>Pendiente</p>
                                        </ng-template>
                                      </div>
                                    </ng-container>
                                  </div>
                                </ng-container>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                      </ng-container>
                    </ng-container>
                  </div>
                </mat-expansion-panel>
              </ng-container>
            </mat-accordion>
          </div>
        </div>
        <div style="background: #fafafa;" class="bigPage_aux">
          <h3 class="mat-h2">Cursos</h3>
          <mat-accordion>
            <ng-container *ngFor="let materia of dataEvento.materias">
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <button style="width: 100%" mat-raised-button
                      color="{{materiaActivaID == materia.id ? 'primary': ''}}"
                      (click)="$event.stopPropagation();setMateriaActivaID(materia.id)">
                      {{materia.nombre}}<br>
                    </button>
                  </mat-panel-title>
                  <mat-panel-description style="align-items:center">{{materia.porcentaje}}%</mat-panel-description>
                </mat-expansion-panel-header>
                <div>
                  <div class="flex-wrap">
                    <button mat-raised-button (click)="fechaCompartir.open()">
                      <mat-icon>share</mat-icon>
                      Compartir con curso
                    </button>
                  </div>
                  <mat-form-field>
                    <input matInput [matDatepicker]="fechaCompartir" (dateChange)="compartirAlumnos($event, materia)"
                      disabled [(ngModel)]="materia.fechaPublicarAlumno">
                    <mat-datepicker #fechaCompartir disabled="false"></mat-datepicker>
                  </mat-form-field>
                  <button class="md-14" mat-icon-button (click)="deleteDate(materia)" *ngIf="canDelete(materia)">
                    <mat-icon class="md-14">close</mat-icon>
                  </button>
                </div>
                <div>
                  <label>Fecha de evidencia</label>
                  <div>
                    <ng-container *ngFor="let fecha of materia.fechas">
                      <small>{{fecha}}</small>
                    </ng-container>
                  </div>
                </div>
              </mat-expansion-panel>
            </ng-container>
          </mat-accordion>
        </div>
      </div>
    </div>
  </div>
  <ng-template #loading>
    <mat-spinner mode="inderminate"></mat-spinner>
  </ng-template>
</div>
